import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import type {IAppDispatch} from "../../store/store";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {setLastAuthAction} from "../state/registration_flow_slice";
import {AuthActionType} from "../types/AuthActionType";
import {advanceRegistrationFlow} from "./advance_registration_flow";
import {confirmSmsLoginSession} from "./confirm_sms_login_session";

export const completeRegistrationWizardSmsLogin = () => async (dispatch: IAppDispatch) => {
    const isSessionConfirmed = await dispatch(
        confirmSmsLoginSession({
            getAuthPayload: ({registrationFlow}) => ({
                userSource: registrationFlow.userSource ?? UserSource.REGISTRATION,
                gtmSourceSection: registrationFlow.gtmSourceSection
            }),
            onSessionConfirmed: () => dispatch(setLastAuthAction({authAction: AuthActionType.LOGIN}))
        })
    ).catch(() => false);

    if (!isSessionConfirmed) {
        dispatch(addNotification({notification: defaultAPIErrorNotification}));
        return;
    }

    await dispatch(advanceRegistrationFlow());
};
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import type {IAppDispatch} from "../../store/store";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {setLastAuthAction} from "../state/registration_flow_slice";
import {AuthActionType} from "../types/AuthActionType";
import {advanceRegistrationFlow} from "./advance_registration_flow";
import {confirmSmsLoginSession} from "./confirm_sms_login_session";

export const completeRegistrationWizardSmsLogin = () => async (dispatch: IAppDispatch) => {
    const isSessionConfirmed = await dispatch(
        confirmSmsLoginSession({
            getAuthPayload: ({registrationFlow}) => ({
                userSource: registrationFlow.userSource ?? UserSource.REGISTRATION,
                gtmSourceSection: registrationFlow.gtmSourceSection
            }),
            onSessionConfirmed: () => dispatch(setLastAuthAction({authAction: AuthActionType.LOGIN}))
        })
    ).catch(() => false);

    if (!isSessionConfirmed) {
        dispatch(addNotification({notification: defaultAPIErrorNotification}));
        return;
    }

    await dispatch(advanceRegistrationFlow());
};
